import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { supplyApi } from '@/app/supplyApi';
import { addressesApi } from '@/features/addresses/addressesApi';
import { auditApi } from '@/features/audit/auditApi';
import authSlice from '@/features/auth/authSlice';
import { biDashboardsApi } from '@/features/biDashboards/biDashboardsApi';
import { mainOrganizationApi } from '@/features/mainOrganization/mainOrganizationApi';
import { organizationsApi } from '@/features/organizations/organizationsApi';
import { rolesApi } from '@/features/roles/rolesApi';
import { servicesApi } from '@/features/services/servicesApi';
import uiSlice from '@/features/ui/uiSlice';

const rootReducer = combineReducers({
  [supplyApi.reducerPath]: supplyApi.reducer,
  [uiSlice.name]: uiSlice.reducer,
  [addressesApi.reducerPath]: addressesApi.reducer,
  [authSlice.name]: authSlice.reducer,
  [mainOrganizationApi.reducerPath]: mainOrganizationApi.reducer,
  [organizationsApi.reducerPath]: organizationsApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [servicesApi.reducerPath]: servicesApi.reducer,
  [auditApi.reducerPath]: auditApi.reducer,
  [biDashboardsApi.reducerPath]: biDashboardsApi.reducer,
});

const middlewares = [
  supplyApi.middleware,
  addressesApi.middleware,
  mainOrganizationApi.middleware,
  organizationsApi.middleware,
  auditApi.middleware,
  biDashboardsApi.middleware,
  rolesApi.middleware,
  servicesApi.middleware,
];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middlewares),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
